import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '@service/util/util.service';
import { COPY_TO_CLIPBOARD_MSGS } from '@domain/constants/app-variables';

@Component({
	selector: 'app-mc-dot-flip-animation',
	templateUrl: './mc-dot-flip-animation.component.html',
	styleUrls: ['./mc-dot-flip-animation.component.scss'],
})
export class McDotFlipAnimationComponent implements OnInit {
	@Input() dot: string = null;
	@Input() mc: string = null;
	@Input() layout: string = 'end end';

	isMCFlipped = false;
	animationState = false;
	COPY_TO_CLIPBOARD_MSGS = COPY_TO_CLIPBOARD_MSGS;

	constructor(public utilService: UtilService) {}

	ngOnInit() {
		if (!this.utilService.isNullOrUndefined(this.mc) && this.mc.length > 0) {
			this.isMCFlipped = false;
		} else {
			if (!this.utilService.isNullOrUndefined(this.dot) && this.dot.length > 0) {
				this.isMCFlipped = true;
			}
		}
	}

	animate() {
		this.isMCFlipped = !this.isMCFlipped;
		this.animationState = false;
		setTimeout(() => {
			this.animationState = true;
		}, 1);
	}
}
